import { useSearch } from '@tanstack/react-router';

export const useCalendarDeepLinkParams = (eventIds?: (string | undefined)[]) => {
  const search = useSearch({ strict: false }) as { eventId?: string };
  const eventId = search.eventId ? decodeURIComponent(search.eventId) : undefined;
  return {
    deepLinkedEventId: eventId,
    isDeepLinkedEvent: !!eventId && !!eventIds?.includes(eventId),
  };
};
